import {
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Logger } from '@utils/logger';
import { Page } from '@bloomreach/spa-sdk';
import { Component as BrComponent } from '@bloomreach/spa-sdk/';
import {
  LiteratureLabelCollection,
  LiteratureLabels,
} from '@literature/literature-label';
import get from 'lodash/get';
import { LiteratureComponentConfig } from '../literature-component.config';
import { LiteratureDisplayComponent } from '../literature-display-component.interface';

const logger = Logger.getLogger('LiteratureEntryComponent');

@Component({
  selector: 'ft-literature-entry',
  templateUrl: './literature-entry.component.html',
  styleUrls: ['./literature-entry.component.scss'],
})
export class LiteratureEntryComponent implements OnInit, OnDestroy {
  @Input() component!: BrComponent;
  @Input() page!: Page;
  @ViewChild('dynamicCmp', { read: ViewContainerRef, static: false }) container;
  componentType: string;
  componentRef: ComponentRef<LiteratureDisplayComponent>;
  componentConfig: LiteratureComponentConfig;
  isLoading = true;
  errorMsg: string;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private changeDetector: ChangeDetectorRef
  ) {}

  ngOnInit() {
    const pageConfig = this.component.getModels();
    const config = this.component.getModels()?.config;
    this.componentType = config.componentType;
    this.loadLiteratureLabels(pageConfig, this.componentType);
    this.componentConfig = LiteratureComponentConfig.getConfig(
      this.componentType
    );
    this.changeDetector.detectChanges(); // at this point show component if componentType exists

    if (this.componentConfig) {
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
        this.componentConfig.component
      );
      this.container.clear();
      this.componentRef = this.container.createComponent(componentFactory);
      this.componentRef.instance.page = this.page; // Pass bloomreach config.
      this.componentRef.instance.component = this.component; // Pass bloomreach config.
      this.isLoading = false;
      this.errorMsg = null;
      this.changeDetector.detectChanges();
    } else {
      logger.error('No component found: ', this.componentType);
      this.errorMsg = `No component found: ${this.componentType}`;
    }
  }
  ngOnDestroy() {
    // clean up dynamic component to avoid memory leaks
    this.componentRef?.destroy();
  }

  loadLiteratureLabels(page, componentType) {
    const accountConfig = get(page, ['ft.core.literature.online.account']);
    if (accountConfig) {
      LiteratureLabels.addLabels(
        LiteratureLabelCollection.accountConfig,
        accountConfig
      );
    }
  }
}
